import { render } from "./VendorChatWidget.vue?vue&type=template&id=4ca63cdb&scoped=true"
import script from "./VendorChatWidget.vue?vue&type=script&lang=js"
export * from "./VendorChatWidget.vue?vue&type=script&lang=js"

import "./VendorChatWidget.vue?vue&type=style&index=0&id=4ca63cdb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca63cdb"]])

export default __exports__